

















































































import Vue from "vue";
import Dropdown from "@/components/shared/Dropdown.vue";
import TextInput from "@/components/shared/TextInput.vue";
import CmsSelect from "@/components/shared/CmsSelect.vue";
import { BLOCKCHAIN_OPTIONS } from "@/config";

const getBlankWebsiteSettings = () => ({
  blockchainId: null,
  cmsId: null,
  websiteUrl: "",
  address: "",
});

export default Vue.extend({
  name: "AddWebsiteModal",

  components: {
    Dropdown,
    TextInput,
    CmsSelect,
  },

  props: {
    show: { type: Boolean, required: true },
  },

  data() {
    return {
      blockchainOptions: BLOCKCHAIN_OPTIONS,
      isAdvancedSetup: false,
      websiteSettings: getBlankWebsiteSettings(),
    };
  },

  methods: {
    onClose() {
      this.$emit("close");
    },

    onSuccess() {
      this.$emit("close");
      this.$emit("success", this.websiteSettings);
    },
  },
});
